import React from 'react';

import { useTheme } from '../../../../hooks/theme';

import { Container } from './styles';

import logoWhiteVertical from '../../../../assets/logo/logo-small-v2.png';
import logoWhiteHorizontal from '../../../../assets/logo/logo-small-w.png';

import logoColorVertical from '../../../../assets/logo/logo-small-v1.png';
import logoColorHorizontal from '../../../../assets/logo/logo-small-w2.png';

interface ILogoProps {
  menuCollapsed: boolean;
}

const Logo: React.FC<ILogoProps> = ({ menuCollapsed }) => {
  const { theme } = useTheme();
  
  return (
    <Container>
      {menuCollapsed && (
        theme === 'dark' ?
          <img className="vertical" src={menuCollapsed ? logoWhiteVertical : logoWhiteHorizontal} alt="Logo" />
          :
          <img className="vertical" src={menuCollapsed ? logoColorVertical : logoColorHorizontal} alt="Logo" />
      )}

      {!menuCollapsed && (
        theme === 'dark' ?
          <img className="horizontal" src={menuCollapsed ? logoColorVertical : logoWhiteHorizontal} alt="Logo" />
          :
          <img className="horizontal" src={menuCollapsed ? logoColorVertical : logoColorHorizontal} alt="Logo" />
      )}

    </Container>
  );
}

export default Logo;